import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { Validators } from '@angular/forms';

/**
 * Definição dos campos do formulário para o briefing de Identidade Visual (Avolumax).
 */
export const IDENTIDADE_VISUAL_FORM_CONFIG: IFieldConfig[] = [
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '01 - Sobre sua Empresa', 
        name: 'companyDetails', 
        placeholder: 'Do que ela se trata? Quais são os produtos/serviços oferecidos? Há quanto tempo existe? Qual sua missão, visão e valores?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_FILE,
        label: '02 - Logotipo Atual (se houver)',
        name: 'currentLogo', 
        accept: 'image/*,.pdf,.ai,.eps,.psd,.zip,.rar,.doc,.docx,.xls,.xlsx,.ppt,.pptx', // Expandir tipos de arquivo aceitos
        multiple: true, // Permitir múltiplos arquivos
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '03 - Posicionamento e Público-Alvo',
        name: 'positioningTarget',
        placeholder: 'Qual o posicionamento da marca/produto? Quem são os seus consumidores? Qual o target?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '04 - Histórico de Comunicação',
        name: 'communicationHistory',
        placeholder: 'Como a marca/produto já se relaciona no mercado? Quais foram as últimas campanhas veiculadas?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '05 - Objetivo nas Mídias Sociais',
        name: 'socialMediaObjective',
        placeholder: 'Porque essa marca quer estar inserida nas mídias sociais? Para resolver problemas? Vender mais produtos?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '06 - Concorrentes nas Redes Sociais',
        name: 'competitorsSocialMedia',
        placeholder: 'A marca/empresa tem concorrentes que utilizam as redes sociais? (Forneça URLs/links se possível). Como eles interagem? Qual a estratégia, frequência e relevância das publicações?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '07 - Análise do Meio (Redes Sociais)',
        name: 'socialMediaAnalysis',
        placeholder: 'Como a empresa está inserida nas redes sociais? O que falam dela? Como falam dela? (Pode inserir monitoramento já feito)',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '08 - Target (Público nas Redes Sociais)',
        name: 'targetSocialMedia',
        placeholder: 'Com que tipo de pessoa iremos falar através das redes sociais? Quem são? Que tipo de mídia consomem? O que gostam de ouvir, falar e fazer dentro das redes?',        
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '09 - Tom da Comunicação',
        name: 'communicationTone',
        placeholder: 'Como a empresa deseja se relacionar (primeira ou terceira pessoa)? Usa gírias ou modo formal? Emoticons? Abreviações? Responde sempre ou só perguntas específicas? Que tipo de perguntas serão respondidas? Prazo para resposta? Imagens, links, vídeos, sons? Quem pode/não pode ser citado?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '10 - Frequência de Atuação Online',
        name: 'onlineFrequency',
        placeholder: 'Quanto tempo ficarão online por dia? Funcionarão no final de semana?',
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '11 - Estratégias de Mídia Social',
        name: 'socialMediaStrategies',
        placeholder: 'Serão realizadas promoções? Qual a lógica? Respostas automáticas? Gifts para usuários influentes?',
        validation: [Validators.required],
    },
]; 